import { render, staticRenderFns } from "./MovementRefundDetail.vue?vue&type=template&id=4cbac1c2&scoped=true&"
import script from "./MovementRefundDetail.vue?vue&type=script&lang=js&"
export * from "./MovementRefundDetail.vue?vue&type=script&lang=js&"
import style0 from "./MovementRefundDetail.vue?vue&type=style&index=0&id=4cbac1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbac1c2",
  null
  
)

export default component.exports